export default {
  title: 'Renseignements personnels',
  modifyButtonLabel: 'Modifier',
  nameLabel: 'Nom',
  birthDateLabel: 'Date de naissance',
  careOfLabel: 'Destinataire des envois postaux',
  correspondence: {
    label: 'Langue de correspondance',
    fr: 'Français',
    en: 'Anglais',
  },
  emails: {
    title: 'Courriel',
    homeEmailLabel: 'Principal : ',
    workEmailLabel: 'Secondaire : ',
  },
  address: {
    addressTitle: 'Adresse',
    currentAddressTitle: 'Adresse actuelle',
  },
  phones: {
    title: 'Téléphone',
    workPhoneLabel: 'Travail : ',
    homePhoneLabel: 'Maison : ',
    cellPhoneLabel: 'Cellulaire : ',
    faxPhoneLabel: 'Télécopieur : ',
    extentionPhoneLabel: ', poste ',
  },
};
